import styled from 'styled-components';

export const FieldWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  width: 100%;
`;

export const StyledDropdownGroup = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.spacing(4)};
  width: 100%;
`;

export const StyledHeader = styled.div`
  ${({ theme }) => theme.typography.heading3}
`;

export const StyledForm = styled.form`
  background: ${props => props.theme.colors.background.base};
  flex: 1;
  display: grid;
  grid-gap: ${props => props.theme.spacing(8)};
  justify-items: center;
  padding: ${props => props.theme.spacing(0, 5)};
  overflow: auto;
  margin-bottom: 74px; /* 74px for navigation bar */
  h3 {
    margin-bottom: ${props => props.theme.spacing(1)};
    ${props => props.theme.typography.heading4}
  }
  fieldset {
    padding: 0;
  }
`;
